<div class="modal fade admin-modal confirm-download" bsModal="bsModal" tabindex="-1" role="dialog" aria-hidden="true" #reportDownloadInfo="bs-modal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
      <button id="modal-close-button" class="close pull-right" (click)="cancel()" type="button" i18n-aria-label="Close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <div class="modal-header">
        <h2 class="modal-title text-center" i18n="Download in progress.|Text explaining the user that is going to download a file@@notificationUserReportModalHeader">Download in progress...</h2>
      </div>
      <div class="modal-body text-center">
        <p i18n="Notify download in progress Modal Text|Body text of the notification user report@@notificationUserReportModalBodyText">Email notification will be sent to <span class="userEmail">{{data}}</span> once export is complete.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="accept()" type="button" i18n="Dismiss button Text|Text for the dismiss button@@confirmNotificationOk">OK</button>
      </div>
    </div>
  </div>
</div>
